import { useEffect } from 'react';
import { AppAction } from '../redux/action';
import Header from './Header';
import { connect } from "react-redux";
import { moveTo } from '../lib/function';
import { history } from '../history';

const Apps = ({appList, GetAppList}) => {

    useEffect(() => {
        GetAppList('');
    }, []);

    return (
        <>
            <Header />
            <section className="wrapper image-wrapper bg-content bg-cloud">
                <div className="sub-header-none">
                </div>
            </section>
            <section className="wrapper bg-soft-primary apps-visual">
                <div className="container pt-8">
                    <div className="card image-wrapper bg-full bg-image bg-overlay mt-2 shadow-lg">
                        <div className="card-body">
                            <div className="container">
                                <div className="row gx-md-8 gx-xl-12 gy-10 align-items-center text-center text-lg-start">
                                    <div className="col-lg-7 ps-lg-10" data-cues="slideInDown" data-group="page-title" data-delay="900" data-disabled="true">
                                        <h1 className="display-1 mb-4 me-xl-5 me-xxl-0 text-white" data-cue="slideInDown" data-group="page-title" data-delay="900" data-show="true"
                                            style={{
                                                animationName: "slideInDown",
                                                animationDuration: "700ms",
                                                animationTimingFunction: "ease",
                                                animationDelay: "900ms",
                                                animationDirection: "normal",
                                                animationFillMode: "both",
                                            }}>Apps</h1>
                                        <p className="lead fs-23 lh-sm pe-xxl-15 text-white" data-cue="slideInDown" data-group="page-title" data-delay="900" data-show="true"
                                            style={{
                                                animationName: "slideInDown",
                                                animationDuration: "700ms",
                                                animationTimingFunction: "ease",
                                                animationDelay: "1200ms",
                                                animationDirection: "normal",
                                                animationFillMode: "both",
                                            }}><span className="text-gradient gradient-5">Discover and install</span> apps for RAYTeams Cloud.<br />And check out the combination of apps you need.</p>
                                    </div>
                                    <div className="col-lg-5 p-0 text-center">
                                        <img className="img-fluid" src="./assets/img/app-list-visual.png" srcSet="./assets/img/app-list-visual@2x.png 2x" data-cue="fadeIn" data-delay="300" alt="" data-show="true"
                                            style={{
                                                animationName: "fadeIn",
                                                animationDuration: "700ms",
                                                animationTimingFunction: "ease",
                                                animationDelay: "300ms",
                                                animationDirection: "normal",
                                                animationFillMode: "both"
                                            }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper bg-soft-primary apps-list">
                <div className="container pt-10 pb-14">
                    <div className="row gy-6">
                        
                        {
                            appList.map((x,idx) => {
                                return (
                                    <div className="col-md-6 col-lg-4" key={`apps_${idx}`}>
                                        <a href="#" className="card shadow-none lift h-100" onClick={(e) => moveTo(history, e, `/${x.appCode}`)}>
                                            <div className="card-body p-5 d-flex flex-row">
                                                <div className="rounded-circle me-4" style={{ background: "#2f9ccc", border: "5px solid #2f9ccc", width: "60px", height: "60px" }}>
                                                    <img
                                                        className="rounded-circle w-10 h-10"
                                                        src={x.app_icon}
                                                        // srcSet={x.app_icon}
                                                        alt="logcenter" />
                                                </div>
                                                <div>
                                                    <span className={`badge bg-${(x.category === 'app' && 'application') || (x.category === 'converter' && 'converter') || (x.category === 'util' && 'utillity')} rounded py-1 mb-2`}>
                                                        {
                                                            (x.category === 'app' && 'Application') ||
                                                            (x.category === 'converter' && 'Converter') ||
                                                            (x.category === 'util' && 'Utility')
                                                        }
                                                    </span>
                                                    <h4 className="mb-0">{x.appName}</h4>
                                                    <p className="mb-0 text-body" dangerouslySetInnerHTML={{ __html: x.desc }}></p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
            <section className="wrapper bg-light combination-title combi-visual">
                <div className="container">
                    <div className="row pt-14 pb-6">
                        <div className="col-lg-8">
                            <h2 className="display-2 mb-3">Try using a combination of apps!</h2>
                            <p className="lead fs-lg mb-6">Do you need prosthetics or orthodontics?<br />Try combining the apps like this.</p>
                            <div className="row">
                                <div className="col-xl-6">
                                    <ul className="icon-list bullet-bg bullet-soft-primary mt-0 mb-0">
                                        <li className="mt-3"><span><i className="uil uil-check"></i></span><span>기공소에서 필요한 경우</span></li>
                                        <li className="mt-3"><span><i className="uil uil-check"></i></span><span>치과에서 필요한 경우</span></li>
                                        <li className="mt-3"><span><i className="uil uil-check"></i></span><span>치과에서 필요한 경우</span></li>
                                    </ul>
                                </div>
                                <div className="col-xl-6">
                                    <ul className="icon-list bullet-bg bullet-soft-primary mt-0 mb-0">
                                        <li className="mt-3"><span><i className="uil uil-check"></i></span><span>기공소에서 필요한 경우기공소에서 필요한 경우</span></li>
                                        <li className="mt-3"><span><i className="uil uil-check"></i></span><span>치과에서 필요한 경우치과에서 필요한 경우</span></li>
                                        <li className="mt-3"><span><i className="uil uil-check"></i></span><span>치과에서 필요한 경우치과에서 필요한 경우</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 text-center">
                            <img src="./assets/img/app-list-small-visual.png" srcSet="./assets/img/app-list-small-visual@2x.png 2x" className="w-100 mw-300" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper bg-light combination combi-title">
                <div className="container py-6 py-md-8">
                    <div className="row gx-lg-8 gx-xl-12 gy-10 align-items-center">
                        <div className="col-lg-12">
                            <h2 className="display-4 mb-3">Do you need <span className="underline-3 style-3 text-primary">Prosthesis?</span>
                            </h2>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper bg-light combination combi-con">
                <div className="container py-4">
                    <div className="row align-items-center bg-soft-primary combi-card">
                        <div className="col-lg-6 order-2 order-lg-first">
                            <p className="mt-3">Run RAYDent Designer with parameters. Import/Load case files automatically after RAYDent Designer started. Click ‘Export RAYTeams’ after design finished. Export design outputs files in project directory.</p>
                            <p className="mb-6">View the design output that you created in the RAYDent Designer in the SMART Check.</p>
                            <div className="row gx-xl-10 gy-6">
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">01</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Install</h4>
                                            <p className="mb-0">Nulla vitae elit libero pharetra augue dapibus.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">02</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Run</h4>
                                            <p className="mb-0">Vivamus sagittis lacus augue laoreet vel.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">03</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Export</h4>
                                            <p className="mb-0">Cras mattis consectetur purus sit amet.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">04</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Finalize</h4>
                                            <p className="mb-0">Aenean lacinia bibendum nulla sed consectetur.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 offset-md-1">
                            <div className="card me-lg-6">
                                <div className="card-body p-6">
                                    <div className="d-flex flex-row">
                                        <div className="rounded-circle me-4" style={{ background: "#1965d7", border: "5px solid #1965d7", width: "60px", height: "60px" }}>
                                            <img className="rounded-circle w-10 h-10" src="./assets/img/app-icon/img_designer.png" srcSet="./assets/img/app-icon/img_designer.png 2x" alt="SMARTOrtho" />
                                        </div>
                                        <div>
                                            <h4 className="mb-1">RAYDent Designer</h4>
                                            <p className="mb-0">Run RAYDent Designer in RAYTeams</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card ms-lg-13 mt-6">
                                <div className="card-body p-6">
                                    <div className="d-flex flex-row">
                                        <div className="rounded-circle me-4" style={{ background: "#1a2c87", border: "5px solid #1a2c87", width: "60px", height: "60px" }}>
                                            <img className="rounded-circle w-10 h-10" src="./assets/img/app-icon/app_rayteams.svg" srcSet="./assets/img/app-icon/app_rayteams.svg 2x" alt="RAYTeams" />
                                        </div>
                                        <div>
                                            <h4 className="mb-1">d+cam</h4>
                                            <p className="mb-0">Proceed and complete Setup</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card me-lg-6 mt-6">
                                <div className="card-body p-6">
                                    <div className="d-flex flex-row">
                                        <div className="rounded-circle me-4" style={{ background: "#00b4ff", border: "5px solid #00b4ff", width: "60px", height: "60px" }}>
                                            <img className="rounded-circle w-10 h-10" src="./assets/img/app-icon/smart-check.png" srcSet="./assets/img/app-icon/smart-check.png 2x" alt="smart-check" />
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Smart Check</h4>
                                            <p className="mb-0">Create SmartCheck related files</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper bg-light combination combi-title">
                <div className="container py-6 py-md-8">
                    <hr />
                    <div className="row gx-lg-8 gx-xl-12 gy-10 align-items-center">
                        <div className="col-lg-12">
                            <h2 className="display-4 mb-3">Do you need <span className="underline-3 style-3 text-primary">Orthodontics?</span></h2>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper bg-light combination combi-con">
                <div className="container py-4">
                    <div className="row align-items-center bg-soft-primary combi-card">
                        <div className="col-lg-6 order-2 order-lg-first">
                            <p className="mt-3">Run SmartOrtho on RAYTeams, proceed and complete Setup on SmartOrthos, and export rayteams. RAYTEAMS generates SmartCheck related files upon request and uploads them to the cloud when the task is complete.</p>
                            <p className="mb-6">When the task is complete, send Notification to the other party or lab. The lab synchronizes and downloads the project. When synchronization is complete, the SmartCheck button is activated, and click it to review.</p>
                            <div className="row gx-xl-10 gy-6">
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">01</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Install</h4>
                                            <p className="mb-0">Nulla vitae elit libero pharetra augue dapibus.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">02</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Run</h4>
                                            <p className="mb-0">Vivamus sagittis lacus augue laoreet vel.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">03</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Export</h4>
                                            <p className="mb-0">Cras mattis consectetur purus sit amet.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">04</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Finalize</h4>
                                            <p className="mb-0">Aenean lacinia bibendum nulla sed consectetur.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 offset-md-1">
                            <div className="card ms-lg-6">
                                <div className="card-body p-6">
                                    <div className="d-flex flex-row">
                                        <div className="rounded-circle me-4" style={{ background: "#00b4ff", border: "5px solid #00b4ff", width: "60px", height: "60px" }}>
                                            <img className="rounded-circle w-10 h-10" src="./assets/img/app-icon/ing_ortho.png" srcSet="./assets/img/app-icon/ing_ortho.png 2x" alt="SMARTOrtho" />
                                        </div>
                                        <div>
                                            <h4 className="mb-1">SmartOrtho</h4>
                                            <p className="mb-0">Run SmartOrtho in RAYTeams</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card ms-lg-6 mt-6">
                                <div className="card-body p-6">
                                    <div className="d-flex flex-row">
                                        <div className="rounded-circle me-4" style={{ background: "#00b4ff", border: "5px solid #00b4ff", width: "60px", height: "60px" }}>
                                            <img className="rounded-circle w-10 h-10" src="./assets/img/app-icon/smart-check.png" srcSet="./assets/img/app-icon/smart-check.png 2x" alt="smart-check" />
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Smart Check</h4>
                                            <p className="mb-0">Create SmartCheck related files in RAYTeams</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="wrapper bg-light combination combi-con pb-12">
                <div className="container py-4">
                    <div className="row align-items-center bg-soft-primary combi-card">
                        <div className="col-lg-5">
                            <div className="card me-lg-6">
                                <div className="card-body p-6">
                                    <div className="d-flex flex-row">
                                        <div className="rounded-circle me-4" style={{ background: "#02d7ea", border: "5px solid #02d7ea", width: "60px", height: "60px" }}>
                                            <img className="rounded-circle w-10 h-10" src="./assets/img/app-icon/img_rayface.png" srcSet="./assets/img/app-icon/img_rayface.png 2x" alt="RAYFace" />
                                        </div>
                                        <div>
                                            <h4 className="mb-1">RAYFace</h4>
                                            <p className="mb-0">Send from RAYFace to Trio Clear Service</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card me-lg-6 mt-6">
                                <div className="card-body p-6">
                                    <div className="d-flex flex-row">
                                        <div className="rounded-circle me-4" style={{ background: "#4e2273", border: "5px solid #4e2273", width: "60px", height: "60px" }}>
                                            <img className="rounded-circle w-10 h-10" src="./assets/img/app-icon/trio_clear_logo_w.svg" srcSet="./assets/img/app-icon/trio_clear_logo_w.svg 2x" alt="Trio Clear" />
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Trio Clear</h4>
                                            <p className="mb-0">RAYTeams will transfer data to Trio Clear Server</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 offset-md-1">
                            <p className="mt-3">In RAYFace, doctor can click ‘Send to Trio Clear Service’ button to use Trio Clear Service. RAYTeams will transfer data to Trio Clear Server.</p>
                            <p className="mb-6">Data Package : Dental-avatar files and meta data.<br />This process will be proceed automatically and silently, if sign-in already.</p>
                            <div className="row gx-xl-10 gy-6">
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">01</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Install</h4>
                                            <p className="mb-0">Nulla vitae elit libero pharetra augue dapibus.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">02</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Run</h4>
                                            <p className="mb-0">Vivamus sagittis lacus augue laoreet vel.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">03</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Export</h4>
                                            <p className="mb-0">Cras mattis consectetur purus sit amet.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-12 col-xl-6">
                                    <div className="d-flex flex-row">
                                        <div>
                                            <span className="icon btn btn-circle btn-lg btn-primary me-4"><span className="number">04</span></span>
                                        </div>
                                        <div>
                                            <h4 className="mb-1">Finalize</h4>
                                            <p className="mb-0">Aenean lacinia bibendum nulla sed consectetur.</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapState = (state) => {
    const appList = state.AppReducer.appList;
    return { appList };
}

const mapDispatch = dispatch => ({
    GetAppList: (lang) => dispatch(AppAction.GetAppList(lang)),
})

export default connect(mapState, mapDispatch)(Apps);